import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'lazy-image',
  props: {
    src: String,
    large: String,
    preview: Number,
    previewText: String,
    discountImg: String,
    noBgColor: {
      type: Boolean,
      default: false
    },
    noSelect: {
      // 为true时，图片无选中、拖拽、长按保存等事件
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isImageLoaded: false
    };
  },
  created: function created() {
    this.src && this.preLoadImage(this.src);
  },
  watch: {
    src: function src(val) {
      this.preLoadImage(val);
    }
  },
  methods: {
    preLoadImage: function preLoadImage(src) {
      var _this = this;
      if (src) {
        var tempIMG = new Image();
        tempIMG.onload = function () {
          _this.isImageLoaded = true;
        };
        tempIMG.onerror = function () {
          _this.isImageLoaded = false;
        };
        tempIMG.src = src;
      } else {
        this.isImageLoaded = false;
      }
    }
  }
};